/* @flow */
import idx from 'idx';
import * as React from 'react';
import { isEqual } from 'lodash';
import { graphql } from 'react-apollo';
import { connect } from 'react-redux';
import OverlayLoading from 'components/OverlayLoading.jsx';
import NavigationListSection from './NavigationListSection.jsx';
import NavigationListSectionItems from './NavigationListSectionItems.jsx';
import NavigationListSectionActions from './NavigationListSectionActions.jsx';
import ClassNavigationPromotionContainer from 'groups/containers/ClassNavigationPromotionContainer.jsx';
import NavigationQuery from 'queries/navigationList.gql';
import UnreadActions from 'actions/UnreadActions';
import UnreadStore from 'stores/UnreadStore';

import './styles/NavigationList.scss';

export const TOUCH_KEY = 'NAVIGATION_LIST';

type Props = {
  ...NavigationListQuery,
  refetch: () => void,
  loading: boolean,
  touch: any,
};

type State = {
  lastSeenTouch: ?string,
};

class NavigationList extends React.Component<Props, State> {
  state: State = {
    lastSeenTouch: undefined,
  };

  componentDidMount() {
    this.checkForTouch(this.props);

    if (UnreadStore.getUnreads().isEmpty()) {
      UnreadActions.loadUnreads();
    }
  }

  componentWillReceiveProps(nextProps: Props) {
    this.checkForTouch(nextProps);
  }

  shouldComponentUpdate(nextProps: Object) {
    if (this.props.loading !== nextProps.loading) {
      return true;
    }

    const prevSection = idx(this.props, _ => _.me.navigationSections);
    const nextSection = idx(nextProps, _ => _.me.navigationSections);

    if (!isEqual(prevSection, nextSection)) {
      return true;
    }

    return false;
  }

  checkForTouch(props: Props) {
    // We save the touch in component state in case the touch comes in while the component is unmounted
    if (this.state.lastSeenTouch !== props.touch) {
      this.props.refetch();
      this.setState({
        lastSeenTouch: props.touch,
      });
    }
  }

  renderSection = (section: *) => {
    const isDistrictSection = section.key === 'districts';
    return (
      <NavigationListSection key={section.key} title={section.label}>
        <NavigationListSectionActions actions={section.actions || []} />
        <NavigationListSectionItems
          items={section.items || []}
          isDistrictSection={isDistrictSection}
        />
      </NavigationListSection>
    );
  };

  render() {
    const sections = idx(this.props, _ => _.me.navigationSections);
    const { loading } = this.props;

    const navList = sections ? (
      <nav className="NavigationList-content">
        <ClassNavigationPromotionContainer />
        {sections.map(this.renderSection)}
      </nav>
    ) : null;

    return (
      <div className="NavigationList" style={{ position: 'relative' }}>
        {loading && <OverlayLoading />}
        {navList}
      </div>
    );
  }
}

const withNavigation = graphql(NavigationQuery, {
  options: () => ({ notifyOnNetworkStatusChange: true }),
  props: ({ data }) => data,
});

function mapStateToProps(state: Object) {
  return {
    touch: state.touch.get(TOUCH_KEY),
  };
}

export { NavigationList };
// $FlowFixMe
export default withNavigation(
  connect(
    mapStateToProps,
    undefined
  )(NavigationList)
);
